import type { Authority } from 'Services/common/Features/Authority/types'
import { isSuperuser, type UserShape } from 'Services/common/Features/User/userSlice'
import {
  GLOBAL_SECTION_PATHS,
  IS_WALTTI_SERVICE_ENVIRONMENT,
  SALES_MANAGEMENT_ROOT_URL,
  SELECTED_PTA_STORAGE_KEY
} from 'Util/constants'
import type { Location } from 'react-router-dom'

const getSelectedPta = () => {
  return localStorage.getItem(SELECTED_PTA_STORAGE_KEY) ?? ''
}

const isPtaSelectionVisible = (user: UserShape | null, location: Location) => {
  // Check if url path contains sales-management
  const isSalesManagement = location.pathname.includes(SALES_MANAGEMENT_ROOT_URL)

  /**
   * The service environment is WALTTI and
   * the user is superuser and
   * the current path is not sales-management
   */
  return IS_WALTTI_SERVICE_ENVIRONMENT && isSuperuser(user) && !isSalesManagement
}

const isGlobalSection = (location: Location) => {
  return GLOBAL_SECTION_PATHS.some(path => location.pathname.includes(path))
}

const isPtaBannerVisible = (user: UserShape | null, location: Location) => {
  return (
    isPtaSelectionVisible(user, location) && (getSelectedPta() !== '' || isGlobalSection(location))
  )
}

const addEmptyAuthorityOptionForSuperusers = (user: UserShape | null, options: Authority[]) => {
  if (isSuperuser(user)) {
    return [{ id: '', code: '', name: '---------' }, ...options]
  }

  return options
}

export {
  getSelectedPta,
  isGlobalSection,
  isPtaBannerVisible,
  isPtaSelectionVisible,
  addEmptyAuthorityOptionForSuperusers
}
